import React from 'react';
import {
  Box,
  Stack,
  Typography,
  Button,
  Card,
  CardContent,
  CardActions
} from '@mui/material';
import DoorIcon from '@mui/icons-material/DoorFront';
import WindowIcon from '@mui/icons-material/Window';
import PowerIcon from '@mui/icons-material/Power';
import { computeOffsetOnWall, DOOR_DIRECTIONS, Door, Window, ElectricityPoint, DOOR_TYPES, ELECTRICITY_POINT_TYPES} from 'dataModels';
import { addDoor, addWindow, addElectricityPoint } from 'dataModels/wall';
import { updateWall } from 'dataModels/room';

export function CreateScreen({ room, wall, selectedElementPosition, onSelect }) {
  const handleSelect = (type, e) => {
    const offset = computeOffsetOnWall(wall, selectedElementPosition);
    switch (type) {
      case 'door':
        const door = Door(offset, DOOR_TYPES.SWING, DOOR_DIRECTIONS.LEFT);
        const updatedWallWithDoor = addDoor(wall,door);
        const updatedRoomWithDoor = updateWall(room,updatedWallWithDoor);
        onSelect(updatedRoomWithDoor, type, door);
        break;
      case 'window':
        const window = Window(offset);
        const updatedWallWithWindow = addWindow(wall,window);
        const updatedRoomWithWindow = updateWall(room,updatedWallWithWindow);
        onSelect(updatedRoomWithWindow, type, window);
        break;
      case 'electricityPoint':
        const electricityPoint = ElectricityPoint(offset, ELECTRICITY_POINT_TYPES[0], 0.2);
        const updatedWallWithElectricityPoint = addElectricityPoint(wall,electricityPoint);
        const updatedRoomWithElectricityPoint = updateWall(room,updatedWallWithElectricityPoint);
        onSelect(updatedRoomWithElectricityPoint, type, electricityPoint);
        break;
    }
  };

  return (
    <Box sx={{ flex: 1, overflowY: 'auto', p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h6" gutterBottom>
        מה תרצה ליצור?
      </Typography>
      
      <Stack spacing={2} sx={{ mt: 2 }}>
        {/* Door Option */}
        <Card 
          sx={{ 
            cursor: 'pointer',
            '&:hover': { 
              boxShadow: 4,
              transform: 'translateY(-2px)',
              transition: 'all 0.2s'
            }
          }}
          onClick={(e) => handleSelect('door', e)}
        >
          <CardContent>
            <Stack direction="row" spacing={2} alignItems="center">
              <DoorIcon sx={{ fontSize: 40, color: 'primary.main' }} />
              <Box>
                <Typography variant="h6">דלת</Typography>
                <Typography variant="body2" color="text.secondary">
                  הוסף דלת חדשה לקיר
                </Typography>
              </Box>
            </Stack>
          </CardContent>
          <CardActions>
            <Button size="small" onClick={(e) => handleSelect('door', e)}>
              בחר
            </Button>
          </CardActions>
        </Card>

        {/* Window Option */}
        <Card 
          sx={{ 
            cursor: 'pointer',
            '&:hover': { 
              boxShadow: 4,
              transform: 'translateY(-2px)',
              transition: 'all 0.2s'
            }
          }}
          onClick={(e) => handleSelect('window', e)}
        >
          <CardContent>
            <Stack direction="row" spacing={2} alignItems="center">
              <WindowIcon sx={{ fontSize: 40, color: 'primary.main' }} />
              <Box>
                <Typography variant="h6">חלון</Typography>
                <Typography variant="body2" color="text.secondary">
                  הוסף חלון חדש לקיר
                </Typography>
              </Box>
            </Stack>
          </CardContent>
          <CardActions>
            <Button size="small" onClick={(e) => handleSelect('window', e)}>
              בחר
            </Button>
          </CardActions>
        </Card>

        {/* Electricity Point Option */}
        <Card 
          sx={{ 
            cursor: 'pointer',
            '&:hover': { 
              boxShadow: 4,
              transform: 'translateY(-2px)',
              transition: 'all 0.2s'
            }
          }}
          onClick={(e) => handleSelect('electricityPoint', e)}
        >
          <CardContent>
            <Stack direction="row" spacing={2} alignItems="center">
              <PowerIcon sx={{ fontSize: 40, color: 'primary.main' }} />
              <Box>
                <Typography variant="h6">נקודת חשמל</Typography>
                <Typography variant="body2" color="text.secondary">
                  הוסף נקודת חשמל חדשה לקיר
                </Typography>
              </Box>
            </Stack>
          </CardContent>
          <CardActions>
            <Button size="small" onClick={(e) => handleSelect('electricityPoint', e)}>
              בחר
            </Button>
          </CardActions>
        </Card>
      </Stack>
    </Box>
  );
}

